<template>
  <div id="app">
    <component :is="themeComponent"/>
  </div>
</template>

<script>
import {DOMAIN_GOOGLE_GTAG, METATAGMAP} from "./utils/constant"
import {getDomainList, getGaCode, getGatagFile, getInviteCodeFile} from "./utils/request";
import Vue from "vue";
export default {
  name: 'App',
  data() {
    return {
      googleGtag: null,
      domainList:[]
    }
  },
  computed: {
    themeComponent: function() {
      const compMap = window.componentsConfig
      const theme = process.env.theme
      console.log(process.env.theme)
      return () => Promise.resolve(require(`${compMap[theme]}`))
    }
  },
  created() {
    this.setDomainGoogleGtag();
    this.getGaTagData();
    this.getInviteData();
    this.getMetaTag();
    this.getDomains();
  },
  methods: {
    getMetaTag(){
      const st = document.createElement('meta')
      const host = window.location.host;
      const meta = METATAGMAP[host];
      if(meta){
        st.name = meta.name
        st.content = meta.content
        document.head.append(st);
      }
    },
    async getGaTagData(){
      const {status,body} = await getGatagFile()
      if (status === 200){
        this.googleGtag = body
        await this.setDomainGoogleGtag();
      } else {
        this.googleGtag = DOMAIN_GOOGLE_GTAG
        await this.setDomainGoogleGtag();
      }
    },
    async setDomainGoogleGtag() {
      const host = location.host
      if (Object.keys(this.googleGtag).indexOf(host) !== -1) {
        this.createGa(this.googleGtag[host])
      } else {
        const json = {
          page: 1,
          size: 300,
          url: host
        };
        const res =  await getGaCode(json);
        if(res.body.code==200||res.body.code==0){
          const data = res.body.data
          const obj = data.pageBean.list.find(({url}) => window.location.origin.indexOf(url)>-1)||{}
          this.createGa(obj.remark)
          Vue.prototype.inviteCode = ''
        }
      }
    },
    createGa(tagId){
      if (tagId){
        const st = document.createElement('script')
        st.async = true
        st.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`
        document.body.append(st)
        let innHtml = `window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${tagId}');`
        let st2 = document.createElement('script')
        st2.type = "text/javascript";
        st2.innerHTML = innHtml;
        document.body.append(st2);
      }
    },
    async getInviteData(){
      const data = await getInviteCodeFile();
      const {status,body} = data
      if (status === 200){
        Vue.prototype.inviteCodeObj = body
      }
    },
    async getDomains(){
      const {status,body} = await getDomainList()
      if (status === 200){
        // Vue.prototype.domainList
        this.domainList = [...new Set(body['list'].map(item=>item['api_url']))]
        await this.checkWebsiteStatus(this.domainList.shift())
      }
    },
    async checkWebsiteStatus(url) {
      try {
        const response = await fetch(url, { method: 'HEAD', mode: 'no-cors' });
        console.error('fetch..',response, url)
        // console.error(`${url}这里是正常的。。 is reachable.`);
        Vue.prototype.loadDomain = url
      } catch (error) {
        if (error.message === 'Failed to fetch') {
          await this.checkWebsiteStatus(this.domainList.shift())
          console.error(`${url}is not reachable. Error: ${error.message}`);
        }
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>



// WEBPACK FOOTER //
// src/App.vue